import { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import CreateAction from '../../components/operational/createAction';
import OrderIsNotExist from './OrderIsNotExist';
import SecondaryButton from '../../components/ui/SecondaryButton';
import { useNavigate } from 'react-router-dom';
import AddPhoneNoti from './AddPhoneNoti';
import LayeredDashboardModal from './Modals/LayeredDashboardModal';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';

const Notifications = ({ tab }) => {
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [isActive, setIsActive] = useState(false);
  const [activeNotification, setActiveNotification] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getNotifications = async () => {
    const response = await CreateAction({
      method: 'post',
      data: {
        page: currentPage,
        limit: rows,
      },
      path: `/dataNotifications`,
      showPreLoader: true,
      isFileUploading: false,
      hideToastMessages: true,
    });

    if (response?.error) return;

    console.log('response?.result', response?.result);

    console.log('currentPage', currentPage);
    console.log('rows', rows);

    const fetchedNotifications = response?.result?.resultData?.notifications;
    const totalNotification = response?.result?.resultData?.totalNotification;

    const sortedNotifications = fetchedNotifications.sort((a, b) => {
      if (a.status === 'DRAFT' && b.status !== 'DRAFT') return -1;
      if (a.status !== 'DRAFT' && b.status === 'DRAFT') return 1;
      return 0;
    });
    setNotifications(sortedNotifications);
    setTotalRecords(totalNotification);
    setLoading(false);
  };

  useEffect(() => {
    getNotifications();
  }, [currentPage, rows]);

  const statusTemplate = notifications => {
    return (
      <>
        {notifications?.status === 'SENT' || notifications?.status === 'SENDING' ? (
          <div className="text-[#26D39A] text-left">Gönderildi</div>
        ) : notifications?.status === 'UNSENT' ? (
          <div className="text-[#F2994A] text-left">Planlandı</div>
        ) :
          (
            <div className="text-[#8A92A6] text-left">Taslak Halinde</div>
          )}
      </>
    );
  };

  const titleTemplate = notifications => {
    return <div className="text-left truncate ">{notifications?.notificationTitle}</div>;
  };

  const sendTimeTemplate = notifications => {
    const date = new Date(notifications?.willSendTime);
    return <div className="text-left">{date?.toLocaleDateString('tr-TR', options)}</div>;
  };

  const numberOfRecipientsTemplate = notifications => {
    return <div className="text-left">{notifications?.success + notifications?.fail}</div>;
  };

  const openRateTemplate = notifications => {
    return <div className="text-left">-</div>;
  };

  const accessRateTemplate = notifications => {
    const success = notifications?.success || 0;
    const fail = notifications?.fail || 0;
    const total = success + fail;
    const accessRate = total > 0 ? (success / (success + fail)) * 100 : 0;
    return <div className="text-left">{accessRate.toFixed(2)}%</div>;
  };

  const handlePageChange = newPage => {
    setCurrentPage(newPage);
  };

  const handleRowsChange = event => {
    setRows(parseInt(event.target.value, 10));
    setCurrentPage(1); // Reset to first page on rows change
  };

  const pageCount = Math.ceil(totalRecords / rows);
  const pageNumbers = [...Array(pageCount).keys()].map(n => n + 1);

  return (
    <div >
      <LayeredDashboardHeader tab={tab}></LayeredDashboardHeader>
      {notifications?.length > 0 ? (
        <div className='h-[calc(100dvh-70px)] overflow-auto'>
          <div className="bg-[#f5f5f5] flex flex-col p-[20px] items-center  pb-[20px] 2lx:pb-[40px]">
            <div className="w-[100%] border rounded-[10px] bg-white p-[45px] ">
              <div className="flex justify-end mb-[30px]">
                <SecondaryButton
                  classes={'text-[14px] bg-[#6F3CE9] text-white py-[15px] px-[20px]'}
                  onClick={() => {
                    setActiveNotification(null);
                    setIsActive(true);
                  }}
                  value={'Bildirim Oluştur'}
                />
              </div>
              <DataTable
                value={notifications}
                loading={loading}
                tableStyle={{ minWidth: '50rem' }}
                rowClassName={'cursor-pointer hover:bg-gray-50'}
                onRowClick={e => {
                  if (e.data.status === 'SENT') {
                    return dispatch(
                      systemSlice.actions.setToastWarn({
                        summary: 'Hata',
                        detail: 'Bu bildirim zaten gönderildiği için düzenlenemez.',
                      }),
                    );
                  }
                  setActiveNotification(e.data);
                  setIsActive(true);
                }}
              >
                <Column
                  body={titleTemplate}
                  header="Başlık"
                  style={{ width: '300px', maxWidth: '300px', height: '50px', fontWeight: '600', fontSize: 14 }}
                ></Column>
                <Column
                  body={statusTemplate}
                  header="Durum"
                  style={{ height: '50px', fontWeight: '500', fontSize: 14 }}
                ></Column>
                <Column
                  body={openRateTemplate}
                  header="Hedef Sayı"
                  style={{ height: '50px', fontWeight: '500', fontSize: 14 }}
                ></Column>
                <Column
                  body={sendTimeTemplate}
                  header="Gönderilme Tarihi"
                  style={{ height: '50px', fontWeight: '500', fontSize: 14 }}
                ></Column>
              </DataTable>

              <div className="flex justify-between items-center mt-4">
                <div className="flex items-center">
                  <span className="mr-2" style={{ fontWeight: '500', fontSize: 14, color: '#60646F' }}>
                    Satır Adedi:
                  </span>
                  <select onChange={handleRowsChange} value={rows} className="border rounded p-1">
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                  </select>
                </div>
                <div className="flex items-center">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-2 py-1"
                  >
                    <svg width="20px" height="20px" viewBox="0 0 0.4 0.4" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.24 0.32a0.02 0.02 0 0 1 -0.014 -0.006l-0.1 -0.1a0.02 0.02 0 0 1 0 -0.028l0.1 -0.1a0.02 0.02 0 1 1 0.028 0.028L0.168 0.2l0.086 0.086A0.02 0.02 0 0 1 0.24 0.32"
                        fill="#C4C8D2"
                      />
                    </svg>
                  </button>
                  {pageNumbers.map(number => (
                    <button
                      key={number}
                      onClick={() => handlePageChange(number)}
                      className={`mx-1 px-2 py-1  ${currentPage === number ? 'text-[#60646F]' : 'text-[#8A92A6]'}`}
                    >
                      {number}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === pageCount}
                    className="px-2 py-1 "
                  >
                    <svg width="20px" height="20px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.2 0.4a0.025 0.025 0 0 1 -0.018 -0.043L0.29 0.25 0.182 0.143a0.025 0.025 0 1 1 0.035 -0.035l0.125 0.125a0.025 0.025 0 0 1 0 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.2 0.4"
                        fill="#C4C8D2"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
          <OrderIsNotExist
            customNotExistClick={() => {
              setActiveNotification(null);
              setIsActive(true);
            }}
            notExistHeader={'Bildirim Oluşturun'}
            notExistDesc={'Bildirimlerinizi oluşturun ve kolayca yönetin.'}
            buttonVal={'Bildirim Oluştur'}
          />
        </div>
      )}
      <LayeredDashboardModal isActive={isActive}>
        <AddPhoneNoti
          setIsActive={setIsActive}
          getNotifications={getNotifications}
          setActiveNotification={setActiveNotification}
          activeNotification={activeNotification}
          tab={{
            ...tab,
            activeTabs: [...tab?.activeTabs, 'Bildirimi Ekle'],
            activeTabTitles: [...tab?.activeTabTitles, 'Bildirimi Ekle'],
          }}
        ></AddPhoneNoti>
      </LayeredDashboardModal>
    </div>
  );
};

export default Notifications;
